// import React from 'react';
// import '../styles/contact.css';
// import { IoLogoInstagram ,IoLocation,
//     IoCall,
//     IoMailOpen} from 'react-icons/io5';

// const Contact = () => {
//     return (
//       <div className="contact-container">
//         <h1 className="mb-5">Contact Us</h1>        
//         <p><IoLocation className="icon" /> Chennai 600021, Tamil Nadu, India</p>
//         <p><IoCall className="icon" /> Phone: 9092483530</p>
//         <p><IoMailOpen className="icon" /> Email: <a href="mailto:yaacabss@gmail.com">yaacabss@gmail.com</a></p>
//         <a href="https://www.instagram.com/yaacabs" target="_blank" rel="noopener noreferrer">
//           <IoLogoInstagram className="icon" /> yaacabes (Instagram)
//         </a>
//       </div>
//     );
//   };


// export default Contact;

import React from 'react';
import '../styles/contact.css';

import { IoLogoInstagram ,
    IoCall,
    IoMailOpen} from 'react-icons/io5';
    import { GrMap } from "react-icons/gr";

const Contact = () => {

  const latitude = 13.1130105; 
  const longitude = 80.2780618;
  const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`;

  return (
    <div className="about-us-container">      
      <div className="contact-info">
        <h2>Contact Info</h2>
        <div className="contact-item">
        <p><GrMap className="icon" /> West Cemetry Road, Old Washermenpet, Chennai 600021, Tamil Nadu, India        
        <br />
        <a href={googleMapsUrl} target="_blank" rel="noopener noreferrer">
          View on Google Maps
        </a>
        </p>
        </div>
        <div className="contact-item">
        <p><IoCall className="icon" /> Phone: <p><a href="tel:9092483530">+91-90924 83530</a></p>
        <p><a href="tel:9092483530">+91-87788 07580</a></p>
        <p><a href="tel:9092483530">+91-94423 48793</a></p>
        <p><a href="tel:9092483530">+91-99625 22423</a></p>
        </p>
        </div>
        <div className="contact-item">
        <p><IoMailOpen className="icon" /> Email: <a href="mailto:yaacabss@gmail.com">yaacabss@gmail.com</a></p>
        </div>
      </div>
      <div className="social-links">
        <h2>Social Links</h2>
        <div className="instagram-link">          
          <a href="https://www.instagram.com/yaacabs" target="_blank" rel="noopener noreferrer">
           <IoLogoInstagram  size={24}/> <span>yaacabs</span>
         </a>
        </div>
      </div>
    </div>
  );
};

export default Contact;